import script from "./cguManagers.vue?vue&type=script&setup=true&lang=js"
export * from "./cguManagers.vue?vue&type=script&setup=true&lang=js"

import "./cguManagers.vue?vue&type=style&index=0&id=345ec798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345ec798"]])

export default __exports__